export function getMetaCSRFToken(): string | undefined {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta?.getAttribute("content") ?? undefined;
}

export function getCookieCSRFToken(): string | undefined {
  const cookie = document.cookie
    .split(";")
    .find((c) => c.trim().startsWith("CSRF-TOKEN="));
  return cookie?.split("=")[1];
}

export function getCSRFToken(
  strategy: "cookieOnly" | "metaOnly" = "cookieOnly",
): string | undefined {
  if (strategy === "metaOnly") {
    return getMetaCSRFToken();
  }

  return getCookieCSRFToken();
}
